import { Badge } from '../../Badge/Badge'
import { formatVenueSlugLabel } from '../../../helpers/formatVenueSlugLabel'
import type { ColumnDef } from '../../DataTable/DataTable'
import type {
  InventorySystemProfileToVenueDTO,
  InventorySystemProfileDTO,
  VenueDTO,
  TenantGroupDTO,
} from '../../../types'

export function buildInventorySystemProfileToVenuesTableColumns(
  profiles: InventorySystemProfileDTO[],
  venues: VenueDTO[],
  tenantGroups: TenantGroupDTO[]
): ColumnDef<InventorySystemProfileToVenueDTO>[] {
  const profileById = new Map(profiles.map((p) => [p.id, p]))
  const venueById = new Map(venues.map((v) => [v.id, v]))
  const groupById = new Map(tenantGroups.map((g) => [g.id, g]))
  const formatVenueLabel = (venueId: string) => {
    const venue = venueById.get(venueId)
    return venue ? formatVenueSlugLabel(venue) : venueId
  }

  return [
    {
      header: 'ISP Profile',
      sortValue: (m) =>
        profileById.get(m.inventorySystemProfileId)?.code ??
        m.inventorySystemProfileId,
      accessor: (m) => {
        const code =
          profileById.get(m.inventorySystemProfileId)?.code ??
          m.inventorySystemProfileId
        return <Badge color="grey">{code}</Badge>
      },
    },
    {
      header: 'Venue',
      sortValue: (m) => formatVenueLabel(m.venueId),
      accessor: (m) => (
        <Badge color="grey">{formatVenueLabel(m.venueId)}</Badge>
      ),
    },
    {
      header: 'Tenant Group',
      sortValue: (m) => groupById.get(m.tenantGroupId)?.code ?? m.tenantGroupId,
      accessor: (m) => {
        const code = groupById.get(m.tenantGroupId)?.code ?? m.tenantGroupId
        return <Badge color="grey">{code}</Badge>
      },
    },
  ]
}
